import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import React from 'react';
import { useHistory } from 'react-router-dom';

import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '5px',
      '&:hover': {
        cursor: 'pointer',
        borderBottom: 'solid 5px',
        borderColor: theme.palette.text.disabled,
        marginBottom: '0',
      },
    },
    selected: (props: any) => props.selected ? ({
      borderBottom: 'solid 5px',
      borderColor: theme.palette.text.disabled,
      marginBottom: '0',
    }) :
      ({
        borderBottom: 'none',
      }),
  }),
);

interface HeaderNavItemProps {
  title: string;
  selected?: boolean;
  href?: string;
  onClick?: (() => void) | ((event: any) => void);
  tooltip?: string;
}

export default function HeaderNavItem(props: HeaderNavItemProps): JSX.Element {
  const classes = useStyles({
    ...baseTheme,
    ...props,
  });
  const history = useHistory();

  const handleClick = (event: any) => {
    event.preventDefault();
    if (props.href) {
      history.push(props.href);
    } else {
      console.log('you did not provide an href for this header link');
    }
  };

  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: `1px solid ${theme.palette.primary.main}`,
    },
  }))(Tooltip);

  return props.tooltip
    ? (
      <HtmlTooltip
        title={
          <React.Fragment>
            <Typography>
              {props.tooltip}
            </Typography>
          </React.Fragment>
        }
      >
        <Grid
          item
          className={`${classes.root} ${classes.selected}`}
          onClick={props.onClick || handleClick}>
          {props.title}
        </Grid>
      </HtmlTooltip>
    )
    : (
      <Grid
        item
        className={`${classes.root} ${classes.selected}`}
        onClick={props.onClick || handleClick}>
        {props.title}
      </Grid>);
}
